<template>
  <div class="insights">
    <div class="insights__tabs">
      <div class="insights__headerRow">
        <div class="insights__headerRow__tabName">{{ insightsHeaderText }}</div>
        <!-- <div class="insights__headerRow__moreIcon">
          <img class="icon" :src="moreIcon">
        </div> -->
      </div>
      <scroll-panel class="insights__tabular-area">
        <primary
          :primaryInsights="workbenchSlottedValue || undefined"
          :loadingInsights="loadingInsights"
        ></primary>
      </scroll-panel>
      <div class="insights__tabs__insightButtonRow">
        <interactive-simple-button
          :disabled="disableUpdateInsights"
          @click.native="updateInsights"
          :label="buttonText"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import ScrollPanel from '@/components/common/scrollPanel'
  import TabsComponents from '@/components/common/tabs'
  import Primary from './primary'
  import Secondary from './secondary'
  import { QUERY_FOR_DATA } from '@/appLogic/workbench/common/store/actions'
  import { InteractiveSimpleButton } from '@/components/common/simpleButton'
  import MoreIcons from '@/assets/Xandr/newMoreIcon-sm.png'
  import { ACTIVATION_STATUS, DESTINATIONS } from '@/appLogic/targets/Constants'
  import { mapGetters } from 'vuex'

  const { Tabs, Tab } = TabsComponents

  export default {
    components: {
      ScrollPanel,
      Tabs,
      Tab,
      Primary,
      Secondary,
      InteractiveSimpleButton,
    },
    props: {
      workbenchSlottedValue: {
        type: Object,
        default: undefined,
      },
      viewOnly: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        moreIcon: MoreIcons,
        insightsUpdated: false,
        insightsHeaderText: 'Primary Insights',
        useMockData: this.$store.getters['workbench/xandrUseMockData'],
      }
    },
    mounted() {
      let isDuplicateTargetAction = this.$store.getters['workbench/targetCreateAction']
      if (isDuplicateTargetAction) {
        this.updateInsights()
      }
      const unWatch = this.$watch(
        // watch only once until newWorkbenchTarget is available
        () => this.newWorkbenchTarget,
        wbTarget => {
          if (wbTarget) {
            if (wbTarget.activation_status === ACTIVATION_STATUS.DRAFT) {
              this.useMockData = this.$store.getters['workbench/xandrUseMockData']
              this.setInsightsHeaderText(this.useMockData)
            } else if (
              wbTarget.xandr_data &&
              wbTarget.xandr_data.query &&
              wbTarget.xandr_data.query.counts.isUsingMockData
            ) {
              // Existing Insights is using mock data
              this.setInsightsHeaderText(true)
            } else {
              this.setInsightsHeaderText(false)
            }
            unWatch()
          }
        },
      )
    },
    computed: {
      ...mapGetters({ isUsingMockData: 'workbench/xandrUseMockData' }),
      disableUpdateInsights() {
        let td = this.$store.getters['workbench/newTargetDefinition']
        return (
          (!this.insightsUpdated && this.isDraft && td.length > 0
            ? false
            : (td && td.length === 0) || !this.$store.getters['workbench/xandrUpdateInsightsEnabled']) ||
          this.viewOnly ||
          ((this.isLive || (this.isFailed && !this.$store.getters['workbench/xandrUpdateInsightsEnabled'])) &&
            !this.isDigitalSocialDestination)
        )
      },
      buttonText() {
        return 'Update Insights'
      },
      newWorkbenchTarget() {
        return this.$store.getters['workbench/newWorkbenchTarget']
      },
      loadingInsights() {
        return this.$store.getters['workbench/xandrLoadingInsights']
      },
      isLive() {
        return (this.$store.getters['workbench/newWorkbenchTarget'] || {}).activation_status === ACTIVATION_STATUS.LIVE
      },
      isFailed() {
        return (
          (this.$store.getters['workbench/newWorkbenchTarget'] || {}).activation_status === ACTIVATION_STATUS.FAILED
        )
      },
      isDraft() {
        return (this.$store.getters['workbench/newWorkbenchTarget'] || {}).activation_status === ACTIVATION_STATUS.DRAFT
      },
      isDigitalSocialDestination() {
        return ((this.$store.getters['workbench/newWorkbenchTarget'] || {}).destinations || []).some(destination =>
          [DESTINATIONS.KRUX, DESTINATIONS.LIVERAMP].includes(destination),
        )
      },
    },
    methods: {
      updateInsights() {
        this.insightsUpdated = true
        this.$store.dispatch('workbench/' + QUERY_FOR_DATA)
      },
      setInsightsHeaderText(mockData = true) {
        this.insightsHeaderText = mockData ? 'Primary Insights (Using Mock Data)' : 'Primary Insights'
      },
    },
    watch: {
      isUsingMockData() {
        this.insightsHeaderText = this.isUsingMockData ? 'Primary Insights (Using Mock Data)' : 'Primary Insights'
      },
    },
  }
</script>

<style lang="scss" scoped>
  $slateGray: #435261;
  $lightGrayBackground: #e7ebed;
  $white: white;
  $blue: #0052e6;

  .insights {
    position: relative;
    height: 100%;

    &__headerRow {
      display: flex;
      flex-flow: row nowrap;
      width: 91%;
      justify-content: space-between;
      margin-right: 1.2em;
      // margin-bottom: 1em;
      &__tabName {
        text-transform: uppercase;
        font-weight: bold;
        color: $blue;
      }
      &__moreIcon {
        cursor: pointer;
        .icon {
          height: 7px;
        }
      }
    }

    &__tabular-area {
      margin-bottom: 50px;
      margin-top: 10px;
    }

    &__tabs {
      display: flex;
      flex-flow: column;
      align-items: center;
      height: 100%;
      &__insightButtonRow {
        position: absolute;
        bottom: 0;
        right: 3em;
      }

      .tabs {
        &__list {
          justify-content: flex-start !important;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Insights.vue?0a320e23